import { denormalisedEntities, updatedEntities } from '../util/data';
import { types as sdkTypes } from '../util/sdkLoader';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const ADD_MARKETPLACE_ENTITIES = 'app/marketplaceData/ADD_MARKETPLACE_ENTITIES';
export const ADD_ESTIMATED_TRANSACTION = 'app/marketplaceData/ADD_ESTIMATED_TRANSACTION';

// ================ Reducer ================ //

const initialState = {
  // Database of all the fetched entities.
  entities: {},
};

const merge = (state, sdkResponse) => {
  const apiResponse = sdkResponse.data;
  return {
    ...state,
    entities: updatedEntities({ ...state.entities }, apiResponse),
  };
};

const addEstimatedTransaction = (state, data) => {
  return {
    ...state,
    estimatedTransaction: data,
  }
}

export default function marketplaceDataReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ADD_MARKETPLACE_ENTITIES:
      return merge(state, payload);
    case ADD_ESTIMATED_TRANSACTION:
      return addEstimatedTransaction(state, payload);
    default:
      return state;
  }
}

// ================ Selectors ================ //

/**
 * Get the denormalised listing entities with the given IDs
 *
 * @param {Object} state the full Redux store
 * @param {Array<UUID>} listingIds listing IDs to select from the store
 */
export const getListingsById = (state, listingIds) => {
  const { entities } = state.marketplaceData;
  const resources = listingIds.map(id => ({
    id,
    type: 'listing',
  }));
  const throwIfNotFound = false;
  return denormalisedEntities(entities, resources, throwIfNotFound);
};

/**
 * Get transactions by array of id.
 * @param {Object} state
 * @param {Array<string>} ids
 * @returns {Array<Object>}
 */
export const getTxsByIds = (state, ids) => {
  const refs = ids.map(id => ({ type: 'transaction', id: new UUID(id) }));
  return getMarketplaceEntities(state, refs);
};

/**
 * Get transaction by id.
 * @param {Object} state
 * @param {string} id
 * @returns {Object|null}
 */
export const getTxById = (state, id) => {
  if (!id) {
    return null;
  }
  const txs = getTxsByIds(state, [id]);
  return txs.length ? txs[0] : null;
}

/**
 * Get the denormalised entities from the given entity references.
 *
 * @param {Object} state the full Redux store
 *
 * @param {Array<{ id, type }} entityRefs References to entities that
 * we want to query from the data. Currently we expect that all the
 * entities have the same type.
 *
 * @return {Array<Object>} denormalised entities
 */
export const getMarketplaceEntities = (state, entityRefs) => {
  const { entities } = state.marketplaceData;

  const throwIfNotFound = false;
  return denormalisedEntities(entities, entityRefs, throwIfNotFound);
};

// ================ Action creators ================ //

export const addMarketplaceEntities = sdkResponse => ({
  type: ADD_MARKETPLACE_ENTITIES,
  payload: sdkResponse,
});

export const addMarketplaceEstimatedTx = data => ({
  type: ADD_ESTIMATED_TRANSACTION,
  payload: data,
});
